import { render, staticRenderFns } from "./Encuestassecciones.vue?vue&type=template&id=f5c56ff2"
import script from "./Encuestassecciones.vue?vue&type=script&lang=js"
export * from "./Encuestassecciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports